module.exports = __webpack_public_path__ + "img/graphics-9.1527f95e.svg";